import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';

import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconButton from 'components/common/IconButton';
import IconRefresh from 'components/icons/IconRefresh';

import { setRouterParamsTabs, removeRouterParamsTabs } from 'redux/modules/routerParams';

import PatientsTabsItem from './PatientsTabsItem';

const styles = theme => ({
  root: {
    position: 'sticky',
    zIndex: 3,
    top: 64,
    padding: '0 30px 0 16px',
    margin: '-16px -30px 16px',
    backgroundColor: theme.palette.primary.A200,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  rootVariantPatient: {
    margin: 0,
  },
  iconButton: {
    margin: '-2px 0 -10px',
    zIndex: 1300,
  },
  iconRefresh: {
    display: 'block',
    width: 16,
    height: 16,
    margin: '0 20px',
  },
});

class PatientsTabs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
    };

    this.onRemoveOtherTabsButtonClick = this.onRemoveOtherTabsButtonClick.bind(this);
    this.onRemoveOtherTabsSubmit = this.onRemoveOtherTabsSubmit.bind(this);
    this.onRemoveOtherTabsCancel = this.onRemoveOtherTabsCancel.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
  }

  onRemoveOtherTabsButtonClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  onRemoveOtherTabsSubmit() {
    const { location, actions, tabs } = this.props;
    const currentTab = tabs.find(item => location.pathname === item.path);
    actions.setRouterParamsTabs({
      patient: currentTab ? [currentTab] : [],
    });
    this.setState({ anchorEl: null });
  }

  onRemoveOtherTabsCancel() {
    this.setState({ anchorEl: null });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  render() {
    const {
      tabs,
      variant,
      history,
      loading,
      location,
      actions,
      classes,
    } = this.props;
    const { anchorEl } = this.state;
    const tabsToRemove = tabs.filter(item => item.path !== location.pathname);
    return (
      <Toolbar
        className={classNames(classes.root, {
          [classes.rootVariantPatient]: variant === 'patient',
        })}
        disableGutters
      >
        <IconButton
          className={classes.iconButton}
          onClick={this.onRemoveOtherTabsButtonClick}
          disabled={tabsToRemove.length === 0}
          tooltipContent="Remove all other tabs"
        >
          <IconRefresh className={classes.iconRefresh} />
        </IconButton>
        <Menu
          id="remove-other-tabs-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.onMenuClose}
          list={false}
          maxHeight={244}
          placement="bottom-left"
        >
          <DeleteMenu
            text="Are you sure you want to remove all other tabs?"
            onCancel={this.onRemoveOtherTabsCancel}
            onSubmit={this.onRemoveOtherTabsSubmit}
            submitButtonText="Remove"
          />
        </Menu>
        <PatientsTabsItem
          href="/charts"
          main
          active={location.pathname === '/charts'}
          variant={variant}
          loading={loading}
        >
          Charts
        </PatientsTabsItem>
        {tabs.map((item, index) => (
          <PatientsTabsItem
            key={item.ID}
            href={item.path}
            active={location.pathname === item.path}
            variant={variant}
            loading={loading}
            {...location.pathname !== item.path
              ? { style: { zIndex: Object.keys(tabs).length - index } }
              : {}}
            onRemove={() => {
              if (location.pathname === item.path) {
                history.push('/charts');
              }
              actions.removeRouterParamsTabs({
                patient: [item.ID],
              });
            }}
          >
            {item.title}
          </PatientsTabsItem>
        ))}
      </Toolbar>
    );
  }
}

PatientsTabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  variant: PropTypes.oneOf(['charts', 'patient']),
  loading: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  actions: PropTypes.shape({
    setRouterParamsTabs: PropTypes.func.isRequired,
    removeRouterParamsTabs: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootVariantPatient: PropTypes.string.isRequired,
    iconButton: PropTypes.string.isRequired,
    iconRefresh: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsTabs.defaultProps = {
  variant: 'charts',
  loading: false,
};

const mapStateToProps = store => ({
  tabs: store.routerParams.tabs.patient,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ setRouterParamsTabs, removeRouterParamsTabs }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(PatientsTabs),
));



// WEBPACK FOOTER //
// ./src/components/patient/PatientsTabs/PatientsTabs.js